var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#344054",
    d: "M.911 5.59a.833.833 0 0 1 0-1.179l3.333-3.333a.833.833 0 0 1 1.179 1.179l-1.91 1.91H16.5a.833.833 0 1 1 0 1.667H3.512l1.91 1.91a.833.833 0 1 1-1.178 1.18z"
  })));
};
export default SvgArrow;